// extracted by mini-css-extract-plugin
export default {"root":"costProfile_root__b1+bq","header":"costProfile_header__w+Ljy"};